import { useState } from "react";
import RecHomeNavbar from "../RecHomeNavbar";
import { JobsTable } from './components/JobsTable'
import { JobsFilter } from './components/JobsFilter'
import { JobsStats } from './components/JobsStats'

export default function MyJobs() {
    const [filterStatus, setFilterStatus] = useState('all')
    const [searchQuery, setSearchQuery] = useState('')
    const [refreshKey, setRefreshKey] = useState(0)

    return (
        <>
            <RecHomeNavbar />
            <div className="mt-12 p-4 flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
                <main className="flex-1 container mx-auto px-4 py-8">
                    <div className="mb-8">
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Job Listings</h1>
                        <p className="text-gray-600 dark:text-gray-400 mt-1">
                            Manage your posted job opportunities
                        </p>
                    </div>
                    <JobsStats key={refreshKey} />
                    <div className="mt-8">
                        <JobsFilter
                            filterStatus={filterStatus}
                            setFilterStatus={setFilterStatus}
                            searchQuery={searchQuery}
                            setSearchQuery={setSearchQuery}
                        />
                    </div>
                    <div className="mt-6">
                        <JobsTable 
                            filterStatus={filterStatus} 
                            searchQuery={searchQuery} 
                            onJobUpdated={() => setRefreshKey(prev => prev + 1)} 
                        />
                    </div>
                </main>
            </div>
        </>
    );
}